import React, { Component } from 'react';
import Layout from './components/Layout';

class App extends Component {
  render() {
    return (<Layout match={this.props.match}/>);
  }
}

export default App;
